import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { DateFnsModule } from "ngx-date-fns";
import { RoundingDialogComponent } from "./rounding-dialog.component";

@NgModule({
	declarations: [RoundingDialogComponent],
	imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule, DateFnsModule, TranslateModule],
	exports: [RoundingDialogComponent],
})
export class RoundingDialogModule {}
